<script>
import {defineComponent} from 'vue'
import IconGrid from "@js/components/Icons/IconGrid.vue";
import IconList from "@js/components/Icons/IconList.vue";
import {useCatalogStore} from "@js/store/CatalogStore.js";

export default defineComponent({
    name: "CatalogGridSwitcher",
    components: {IconList, IconGrid},
    setup(){
        const catalogStore = useCatalogStore();

        return {catalogStore}
    }
})
</script>

<template>
    <div v-if="catalogStore.grid_mode" class="flex items-center gap-2">
        <div class="group p-1 rounded md:hover:bg-baseColor transition cursor-pointer"
             :class="{'bg-baseColor': catalogStore.grid_mode === catalogStore.grid_mods.small}"
             @click.prevent="catalogStore.setGridMode(catalogStore.grid_mods.small)">
            <IconGrid class="w-5 h-5 md:w-4 md:h-4 md:group-hover:text-black transition"
                      :class="{'text-black': catalogStore.grid_mode === catalogStore.grid_mods.small,
                      'text-gray-500': catalogStore.grid_mode !== catalogStore.grid_mods.small}"

            />
        </div>
        <div class="group p-0.5 rounded md:hover:bg-baseColor transition cursor-pointer"
             :class="{'bg-baseColor': catalogStore.grid_mode === catalogStore.grid_mods.wide}"
             @click.prevent="catalogStore.setGridMode(catalogStore.grid_mods.wide)">
            <IconList class="w-6 h-6 md:w-5 md:h-5 md:group-hover:text-black transition"
                      :class="{'text-black': catalogStore.grid_mode === catalogStore.grid_mods.wide,
                      'text-gray-500': catalogStore.grid_mode !== catalogStore.grid_mods.wide}"/>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
